export default "__VITE_ASSET__DiwJJNZN__"